import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "./popular.css";

function Popular() {
  const [activeProductId, setActiveProductId] = useState(null);
  const [popularProducts, setPopularProducts] = useState([]);
  const navigate = useNavigate();

  const productState = useSelector((state) => state.products);
  const { loading, error, products = [] } = productState;

  // ✅ Filter only popular products
  useEffect(() => {
    if (products.length > 0) {
      const filtered = products.filter((item) => item.popular === true);
      setPopularProducts(filtered);
    }
  }, [products]);

  const handleModalOpen = (id) => setActiveProductId(id);
  const handleModalClose = () => setActiveProductId(null);
  const handleBuyNow = (productId) => navigate(`/order/${productId}`);

  // ✅ Add to Cart
  async function handleAddToCart(itemId) {
    const user = localStorage.getItem("userDetails");
    if (!user) return alert("Please log in to add products to cart.");

    const userId = JSON.parse(user)._id;

    try {
      const res = await fetch("https://swarna-herbal-backend.onrender.com/api/cart/addItem", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId, itemId: String(itemId), quantity: 1 }),
      });

      const data = await res.json();
      if (res.ok) {
        alert("Item added to your cart");
      } else {
        alert("Failed to add");
        console.error("Error:", data.message);
      }
    } catch (err) {
      console.error("Error:", err);
      alert("Something went wrong. Please try again.");
    }
  }

  return (
    <div className="popular-container">
      {/* Product Highlights Section */}
      <div className="product-highlights">
        <h2>🌟 Our Popular Products</h2>

        {loading ? (
          <p>Loading products...</p>
        ) : error ? (
          <p>Error fetching products.</p>
        ) : popularProducts.length === 0 ? (
          <p>No popular products found.</p>
        ) : (
          <div className="product-cards">
            {popularProducts.map((product) => (
              <div key={product._id} className="product-card">
                <img
                  src={`https://swarna-herbal-backend.onrender.com/uploads/${product.image}`}
                  alt={product.name}
                  className="product-image"
                />
                <div style={{ margin: "5px auto 0" }} className="product-info">
                  <h4>{product.name}</h4>
                  <p className="price">Price - ₹{product.price}</p>
                  <p className="price">Offer Price - ₹{product.offerPrice}</p>
                  <p className="product-short-description">
                    {product.description.length > 150
                      ? `${product.description.slice(0, 150)}...`
                      : product.description}
                  </p>

                  {product.description.length > 150 && (
                    <button
                      className="read-more-btn"
                      onClick={() => handleModalOpen(product._id)}
                    >
                      Read More
                    </button>
                  )}

                  <button
                    style={{ background: "green" }}
                    className="product-btn"
                    onClick={() => handleAddToCart(product._id)}
                  >
                    Add To Cart
                  </button>
                  <button
                    className="product-btn"
                    onClick={() => handleBuyNow(product._id)}
                  >
                    Buy Now
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Modal Popup */}
      {activeProductId && (
        <div className="modal-overlay" onClick={handleModalClose}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              style={{ background: "red", color: "white" }}
              className="close-modal-btn"
              onClick={handleModalClose}
            >
              ×
            </button>
            {popularProducts
              .filter((product) => product._id === activeProductId)
              .map((product) => (
                <div key={product._id}>
                  <img
                    src={`https://swarna-herbal-backend.onrender.com/uploads/${product.image}`}
                    alt={product.name}
                    className="modal-image"
                  />
                  <h3>{product.name}</h3>
                  <p className="modal-price">Price - ₹{product.price}</p>
                  <p className="modal-price">Offer Price - ₹{product.offerPrice}</p>
                  <p className="modal-description">
                    {product.description || "No description available"}
                  </p>
                  <button
                    style={{ background: "green" }}
                    className="buy-now-btn"
                    onClick={() => handleAddToCart(product._id)}
                  >
                    Add To Cart
                  </button>
                  <button
                    className="product-btn"
                    onClick={() => handleBuyNow(product._id)}
                  >
                    Buy Now
                  </button>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default Popular;
